<template>
  <b-dropdown
    class="w-full"
    toggle-class="w-full !bg-[rgba(0,0,0,0)] border !border-[#D0D5DD] hover:bg-[#f3f4f6] flex items-center justify-center gap-2 !px-[30px] !h-[37px] !text-[#344054] !text-[13px] font-[Inter] font-[500] rounded"
    menu-class="w-full max-w-[280px] p-3 mt-2"
    variant="secondary"
    right
  >
    <template #button-content>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.42611 9.5L16.1227 9.5M9.42611 2.375L9.42611 16.625M6.30102 2.375H12.5512C13.8014 2.375 14.4264 2.375 14.9039 2.63386C15.3239 2.86156 15.6654 3.22489 15.8794 3.67177C16.1227 4.17981 16.1227 4.84488 16.1227 6.175V12.825C16.1227 14.1551 16.1227 14.8202 15.8794 15.3282C15.6654 15.7751 15.3239 16.1384 14.9039 16.3661C14.4264 16.625 13.8014 16.625 12.5512 16.625H6.30102C5.05087 16.625 4.42579 16.625 3.9483 16.3661C3.52828 16.1384 3.1868 15.7751 2.97279 15.3282C2.72949 14.8202 2.72949 14.1551 2.72949 12.825V6.175C2.72949 4.84488 2.72949 4.17981 2.97279 3.67177C3.1868 3.22489 3.52828 2.86156 3.9483 2.63386C4.42579 2.375 5.05087 2.375 6.30102 2.375Z"
          stroke="#464646"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      Screen Layout
    </template>

    <div>
      <!--      <div class="text-[14px] text-black font-semibold mb-2">-->
      <!--        Screen Layout-->
      <!--      </div>-->

      <!--      <div class="grid grid-cols-2 gap-[6px] mb-4">-->
      <!--        <button-->
      <!--          class="p-0"-->
      <!--          @click="selectLayout('layout7')"-->
      <!--        >-->
      <!--          <svg-->
      <!--            width="133"-->
      <!--            height="77"-->
      <!--            viewBox="0 0 133 77"-->
      <!--            fill="none"-->
      <!--            xmlns="http://www.w3.org/2000/svg"-->
      <!--            class="w-full"-->
      <!--          >-->
      <!--            <rect-->
      <!--              x="0.606445"-->
      <!--              y="1.14062"-->
      <!--              width="132.108"-->
      <!--              height="75.7062"-->
      <!--              rx="7.57062"-->
      <!--              fill="#F3F3F3"-->
      <!--            />-->
      <!--            <rect-->
      <!--              x="16.5051"-->
      <!--              y="16.282"-->
      <!--              width="98.4181"-->
      <!--              height="46.1808"-->
      <!--              rx="3.02825"-->
      <!--              stroke="#9E9E9E"-->
      <!--              stroke-width="1.51412"-->
      <!--            />-->
      <!--            <circle-->
      <!--              cx="23.6973"-->
      <!--              cy="23.0955"-->
      <!--              r="1.89266"-->
      <!--              fill="#9E9E9E"-->
      <!--            />-->
      <!--            <circle-->
      <!--              cx="29.754"-->
      <!--              cy="23.0955"-->
      <!--              r="1.89266"-->
      <!--              fill="#9E9E9E"-->
      <!--            />-->
      <!--            <circle-->
      <!--              cx="35.8106"-->
      <!--              cy="23.0955"-->
      <!--              r="1.89266"-->
      <!--              fill="#9E9E9E"-->
      <!--            />-->
      <!--          </svg>-->
      <!--        </button>-->

      <!--        <button-->
      <!--          class="p-0"-->
      <!--          @click="selectLayout('layout8')"-->
      <!--        >-->
      <!--          <svg-->
      <!--            width="133"-->
      <!--            height="77"-->
      <!--            viewBox="0 0 133 77"-->
      <!--            fill="none"-->
      <!--            xmlns="http://www.w3.org/2000/svg"-->
      <!--            class="w-full"-->
      <!--          >-->
      <!--            <rect-->
      <!--              x="0.285156"-->
      <!--              y="1.14062"-->
      <!--              width="132.108"-->
      <!--              height="75.7062"-->
      <!--              rx="7.57062"-->
      <!--              fill="#F3F3F3"-->
      <!--            />-->
      <!--            <circle-->
      <!--              cx="13.5333"-->
      <!--              cy="13.2537"-->
      <!--              r="1.89266"-->
      <!--              fill="#9E9E9E"-->
      <!--            />-->
      <!--            <circle-->
      <!--              cx="19.5899"-->
      <!--              cy="13.2537"-->
      <!--              r="1.89266"-->
      <!--              fill="#9E9E9E"-->
      <!--            />-->
      <!--            <circle-->
      <!--              cx="25.6466"-->
      <!--              cy="13.2537"-->
      <!--              r="1.89266"-->
      <!--              fill="#9E9E9E"-->
      <!--            />-->
      <!--            <path-->
      <!--              d="M117.251 9.46851H122.55C124.223 9.46851 125.579 10.8243 125.579 12.4968V17.7962"-->
      <!--              stroke="#9E9E9E"-->
      <!--              stroke-width="1.51412"-->
      <!--            />-->
      <!--            <path-->
      <!--              d="M20.3467 65.491L15.0472 65.491C13.3748 65.491 12.019 64.1352 12.019 62.4627L12.019 57.1633"-->
      <!--              stroke="#9E9E9E"-->
      <!--              stroke-width="1.51412"-->
      <!--            />-->
      <!--            <path-->
      <!--              d="M115.019 65.4912L120.318 65.4912C121.99 65.4912 123.346 64.1354 123.346 62.463L123.346 57.1635"-->
      <!--              stroke="#9E9E9E"-->
      <!--              stroke-width="1.51412"-->
      <!--            />-->
      <!--          </svg>-->
      <!--        </button>-->
      <!--      </div>-->

      <!--      <div class="text-[14px] text-black font-semibold mb-2">-->
      <!--        Camera Layout-->
      <!--      </div>-->
      <!--      -->
      <!--      <div class="grid grid-cols-2 gap-[6px] mb-4">-->
      <!--        <button-->
      <!--          class="p-0"-->
      <!--          @click="selectLayout('layout2')"-->
      <!--        >-->
      <!--          <svg-->
      <!--            width="133"-->
      <!--            height="77"-->
      <!--            viewBox="0 0 133 77"-->
      <!--            fill="none"-->
      <!--            xmlns="http://www.w3.org/2000/svg"-->
      <!--            class="w-full"-->
      <!--          >-->
      <!--            <rect-->
      <!--              y="1"-->
      <!--              width="132.108"-->
      <!--              height="75.7062"-->
      <!--              rx="7.57062"-->
      <!--              fill="#F3F3F3"-->
      <!--            />-->
      <!--            <rect-->
      <!--              x="8.75706"-->
      <!--              y="9.75706"-->
      <!--              width="115.486"-->
      <!--              height="58.4859"-->
      <!--              rx="2.27119"-->
      <!--              fill="#F3F3F3"-->
      <!--              stroke="#9E9E9E"-->
      <!--              stroke-width="1.51412"-->
      <!--            />-->
      <!--            <path-->
      <!--              d="M72.5104 45.2359C72.5104 44.2234 72.5104 43.7171 72.3854 43.3052C72.1041 42.3777 71.3782 41.6519 70.4507 41.3705C70.0388 41.2455 69.5325 41.2455 68.52 41.2455H64.8925C63.8799 41.2455 63.3737 41.2455 62.9617 41.3705C62.0342 41.6519 61.3084 42.3777 61.0271 43.3052C60.9021 43.7171 60.9021 44.2234 60.9021 45.2359M69.9711 35.4414C69.9711 37.2445 68.5094 38.7062 66.7062 38.7062C64.9031 38.7062 63.4414 37.2445 63.4414 35.4414C63.4414 33.6383 64.9031 32.1766 66.7062 32.1766C68.5094 32.1766 69.9711 33.6383 69.9711 35.4414Z"-->
      <!--              stroke="#9E9E9E"-->
      <!--              stroke-width="1.51412"-->
      <!--              stroke-linecap="round"-->
      <!--              stroke-linejoin="round"-->
      <!--            />-->
      <!--          </svg>-->
      <!--        </button>-->
      <!--        -->
      <!--        <button-->
      <!--          class="p-0"-->
      <!--          @click="selectLayout('layout1')"-->
      <!--        >-->
      <!--          <svg-->
      <!--            width="133"-->
      <!--            height="77"-->
      <!--            viewBox="0 0 133 77"-->
      <!--            fill="none"-->
      <!--            xmlns="http://www.w3.org/2000/svg"-->
      <!--            class="w-full"-->
      <!--          >-->
      <!--            <rect-->
      <!--              y="1"-->
      <!--              width="132.108"-->
      <!--              height="75.7062"-->
      <!--              rx="7.57062"-->
      <!--              fill="#F3F3F3"-->
      <!--            />-->
      <!--            <path-->
      <!--              d="M116.966 9.32776H122.265C123.938 9.32776 125.293 10.6836 125.293 12.356V17.6554"-->
      <!--              stroke="#9E9E9E"-->
      <!--              stroke-width="1.51412"-->
      <!--            />-->
      <!--            <path-->
      <!--              d="M20.0618 65.3503L14.7623 65.3503C13.0899 65.3503 11.7341 63.9945 11.7341 62.3221L11.7341 57.0227"-->
      <!--              stroke="#9E9E9E"-->
      <!--              stroke-width="1.51412"-->
      <!--            />-->
      <!--            <path-->
      <!--              d="M114.733 65.3503L120.033 65.3503C121.705 65.3503 123.061 63.9945 123.061 62.3221L123.061 57.0227"-->
      <!--              stroke="#9E9E9E"-->
      <!--              stroke-width="1.51412"-->
      <!--            />-->
      <!--            <path-->
      <!--              d="M74.5104 44.2358C74.5104 43.2233 74.5104 42.7171 74.3854 42.3051C74.1041 41.3776 73.3782 40.6518 72.4507 40.3704C72.0388 40.2455 71.5325 40.2455 70.52 40.2455H66.8925C65.8799 40.2455 65.3737 40.2455 64.9617 40.3704C64.0342 40.6518 63.3084 41.3776 63.0271 42.3051C62.9021 42.7171 62.9021 43.2233 62.9021 44.2358M71.9711 34.4413C71.9711 36.2445 70.5094 37.7062 68.7062 37.7062C66.9031 37.7062 65.4414 36.2445 65.4414 34.4413C65.4414 32.6382 66.9031 31.1765 68.7062 31.1765C70.5094 31.1765 71.9711 32.6382 71.9711 34.4413Z"-->
      <!--              stroke="#9E9E9E"-->
      <!--              stroke-width="1.51412"-->
      <!--              stroke-linecap="round"-->
      <!--              stroke-linejoin="round"-->
      <!--            />-->
      <!--          </svg>-->
      <!--        </button>-->
      <!--      </div>-->

      <!--      <div class="text-[14px] text-black font-semibold mb-2">-->
      <!--        Camera + Screen-->
      <!--      </div>-->
      
      <div class="grid grid-cols-2 gap-[6px]">
        <button
          class="py-0 px-1 rounded h-[60px] flex items-center justify-center"
          :style="{backgroundColor: active === 'layout6' ? 'rgba(61, 130, 234, 0.2)' : 'transparent'}"
          @click="selectLayout('layout6')"
        >
          <svg
            width="133"
            height="77"
            viewBox="0 0 133 77"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-full"
          >
            <rect
              x="0.606445"
              y="1.26489"
              width="132.108"
              height="75.7062"
              rx="7.57062"
              fill="#F3F3F3"
            />
            <rect
              x="16.505"
              y="16.4062"
              width="98.4181"
              height="46.1808"
              rx="3.02825"
              stroke="#9E9E9E"
              stroke-width="1.51412"
            />
            <circle
              cx="102.432"
              cy="55.3949"
              r="14.0056"
              fill="#F3F3F3"
              stroke="#9E9E9E"
              stroke-width="1.51412"
            />
            <path
              d="M108.236 61.1675C108.236 60.155 108.236 59.6487 108.111 59.2368C107.829 58.3093 107.104 57.5834 106.176 57.3021C105.764 57.1771 105.258 57.1771 104.245 57.1771H100.618C99.6052 57.1771 99.099 57.1771 98.687 57.3021C97.7595 57.5834 97.0337 58.3093 96.7523 59.2368C96.6274 59.6487 96.6274 60.155 96.6274 61.1675M105.696 51.373C105.696 53.1761 104.235 54.6378 102.432 54.6378C100.628 54.6378 99.1667 53.1761 99.1667 51.373C99.1667 49.5699 100.628 48.1082 102.432 48.1082C104.235 48.1082 105.696 49.5699 105.696 51.373Z"
              stroke="#9E9E9E"
              stroke-width="1.51412"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle
              cx="23.6972"
              cy="23.2197"
              r="1.89266"
              fill="#9E9E9E"
            />
            <circle
              cx="29.7536"
              cy="23.2197"
              r="1.89266"
              fill="#9E9E9E"
            />
            <circle
              cx="35.8101"
              cy="23.2197"
              r="1.89266"
              fill="#9E9E9E"
            />
          </svg>
        </button>
        
        <button
          class="py-0 px-1 rounded h-[60px] flex items-center justify-center"
          :style="{backgroundColor: active === 'layout3' ? 'rgba(61, 130, 234, 0.2)' : 'transparent'}"
          @click="selectLayout('layout3')"
        >
          <svg
            width="133"
            height="77"
            viewBox="0 0 133 77"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-full"
          >
            <rect
              x="0.285156"
              y="1.26489"
              width="132.108"
              height="75.7062"
              rx="7.57062"
              fill="#F3F3F3"
            />
            <circle
              cx="13.5333"
              cy="13.3778"
              r="1.89266"
              fill="#9E9E9E"
            />
            <circle
              cx="19.5899"
              cy="13.3778"
              r="1.89266"
              fill="#9E9E9E"
            />
            <circle
              cx="25.6466"
              cy="13.3778"
              r="1.89266"
              fill="#9E9E9E"
            />
            <circle
              cx="107.03"
              cy="53.8806"
              r="14.0056"
              fill="#F3F3F3"
              stroke="#9E9E9E"
              stroke-width="1.51412"
            />
            <path
              d="M112.834 59.6533C112.834 58.6408 112.834 58.1346 112.709 57.7226C112.428 56.7951 111.702 56.0693 110.774 55.7879C110.362 55.663 109.856 55.663 108.844 55.663H105.216C104.203 55.663 103.697 55.663 103.285 55.7879C102.358 56.0693 101.632 56.7951 101.351 57.7226C101.226 58.1346 101.226 58.6408 101.226 59.6533M110.295 49.8588C110.295 51.6619 108.833 53.1237 107.03 53.1237C105.227 53.1237 103.765 51.6619 103.765 49.8588C103.765 48.0557 105.227 46.594 107.03 46.594C108.833 46.594 110.295 48.0557 110.295 49.8588Z"
              stroke="#9E9E9E"
              stroke-width="1.51412"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M117.251 9.59253H122.55C124.223 9.59253 125.579 10.9483 125.579 12.6208V17.9202"
              stroke="#9E9E9E"
              stroke-width="1.51412"
            />
            <path
              d="M20.3467 65.615L15.0472 65.615C13.3748 65.615 12.019 64.2592 12.019 62.5867L12.019 57.2873"
              stroke="#9E9E9E"
              stroke-width="1.51412"
            />
          </svg>
        </button>
        
        <button
          class="py-0 px-1 rounded h-[60px] flex items-center justify-center"
          :style="{backgroundColor: active === 'layout5' ? 'rgba(61, 130, 234, 0.2)' : 'transparent'}"
          @click="selectLayout('layout5')"
        >
          <svg
            width="133"
            height="77"
            viewBox="0 0 133 77"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-full"
          >
            <rect
              x="0.606445"
              y="0.541748"
              width="132.108"
              height="75.7062"
              rx="7.57062"
              fill="#F3F3F3"
            />
            <rect
              x="16.5051"
              y="15.6828"
              width="98.4181"
              height="46.1808"
              rx="3.02825"
              stroke="#9E9E9E"
              stroke-width="1.51412"
            />
            <rect
              x="95.9973"
              y="42.9372"
              width="25.084"
              height="24.226"
              rx="2.27119"
              fill="#F3F3F3"
              stroke="#9E9E9E"
              stroke-width="1.51412"
            />
            <path
              d="M114.292 61.2014C114.292 60.1889 114.292 59.6826 114.167 59.2707C113.886 58.3432 113.16 57.6174 112.232 57.336C111.82 57.2111 111.314 57.2111 110.302 57.2111H106.674C105.661 57.2111 105.155 57.2111 104.743 57.336C103.816 57.6174 103.09 58.3432 102.809 59.2707C102.684 59.6826 102.684 60.1889 102.684 61.2014M111.753 51.4069C111.753 53.21 110.291 54.6718 108.488 54.6718C106.685 54.6718 105.223 53.21 105.223 51.4069C105.223 49.6038 106.685 48.1421 108.488 48.1421C110.291 48.1421 111.753 49.6038 111.753 51.4069Z"
              stroke="#9E9E9E"
              stroke-width="1.51412"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <circle
              cx="23.6973"
              cy="22.4964"
              r="1.89266"
              fill="#9E9E9E"
            />
            <circle
              cx="29.754"
              cy="22.4964"
              r="1.89266"
              fill="#9E9E9E"
            />
            <circle
              cx="35.8106"
              cy="22.4964"
              r="1.89266"
              fill="#9E9E9E"
            />
          </svg>
        </button>

        <button
          class="py-0 px-1 rounded h-[60px] flex items-center justify-center"
          :style="{backgroundColor: active === 'layout4' ? 'rgba(61, 130, 234, 0.2)' : 'transparent'}"
          @click="selectLayout('layout4')"
        >
          <svg
            width="133"
            height="77"
            viewBox="0 0 133 77"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="w-full"
          >
            <rect
              x="0.285156"
              y="0.541748"
              width="132.108"
              height="75.7062"
              rx="7.57062"
              fill="#F3F3F3"
            />
            <circle
              cx="13.5333"
              cy="12.6546"
              r="1.89266"
              fill="#9E9E9E"
            />
            <circle
              cx="19.5899"
              cy="12.6546"
              r="1.89266"
              fill="#9E9E9E"
            />
            <circle
              cx="25.6466"
              cy="12.6546"
              r="1.89266"
              fill="#9E9E9E"
            />
            <path
              d="M117.251 8.86938H122.55C124.223 8.86938 125.579 10.2252 125.579 11.8976V17.1971"
              stroke="#9E9E9E"
              stroke-width="1.51412"
            />
            <path
              d="M20.3467 64.8918L15.0472 64.8918C13.3748 64.8918 12.019 63.5361 12.019 61.8636L12.019 56.5642"
              stroke="#9E9E9E"
              stroke-width="1.51412"
            />
            <rect
              x="98.7034"
              y="41.4231"
              width="25.084"
              height="24.226"
              rx="2.27119"
              fill="#F3F3F3"
              stroke="#9E9E9E"
              stroke-width="1.51412"
            />
            <path
              d="M116.998 59.6873C116.998 58.6747 116.998 58.1685 116.873 57.7565C116.592 56.829 115.866 56.1032 114.938 55.8219C114.526 55.6969 114.02 55.6969 113.008 55.6969H109.38C108.367 55.6969 107.861 55.6969 107.449 55.8219C106.522 56.1032 105.796 56.829 105.515 57.7565C105.39 58.1685 105.39 58.6747 105.39 59.6873M114.459 49.8928C114.459 51.6959 112.997 53.1576 111.194 53.1576C109.391 53.1576 107.929 51.6959 107.929 49.8928C107.929 48.0896 109.391 46.6279 111.194 46.6279C112.997 46.6279 114.459 48.0896 114.459 49.8928Z"
              stroke="#9E9E9E"
              stroke-width="1.51412"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </b-dropdown>
</template>

<script>
export default {
  name: 'VideoLayoutSelect',
  props: {
    active: {
      type: String,
      default: ''
    }
  },
  methods: {
    selectLayout (layout) {
      this.$store.commit('liveStream/SET_LAYOUT', layout)
    }
  }
}
</script>
